import Cookies from 'js-cookie';
import jstree from 'jstree';
import gsap from 'gsap';

// Breakpoints considered as "mobile" for the active filter tags display
const MOBILE_BREAKPOINTS = ['xsmall', 'small'];

var EventListingsWithFilters = function (options) {

	this.options = {
		$el: false,
		baseClass: 'comp-EventListingsWithFilters',
	};

	$.extend(true, this.options, options);

};

EventListingsWithFilters.prototype.init = function () {

	let self = this;
	
	this.componentId = this.options.$el.attr('id');

	this.pulsateFiltersTimeline = null;

	this.$filterWrappers = this.options.$el.find(`.${self.options.baseClass}__dropdownFilterWrapper`);
	this.$dropdownFilterPulsors = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter__pulsor`);
	this.$dropdownFilterHeadings = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter__heading`);

	this.$topicFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--topic .${self.options.baseClass}__dropdownFilter__filter`);
	this.$topicFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--topic`);
	this.$industryFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--industry .${self.options.baseClass}__dropdownFilter__filter`);
	this.$industryFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--industry`);
	this.$typeFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--type .${self.options.baseClass}__dropdownFilter__filter`);
	this.$typeFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--type`);

	this.selectedDropdownFilterClass = `${self.options.baseClass}__dropdownFilter--selected`;

	this.$activeFilterTags = this.options.$el.find(`.${self.options.baseClass}__activeFilterTag`);
	this.$submitFiltersButton = this.options.$el.find(`.${self.options.baseClass}__submitFiltersButton`);
	this.submitFiltersButtonLoadingClass = `${self.options.baseClass}__submitFiltersButton--loading`;

	this.initFilters();

	// get our URL parameters
	let searchParams = new URLSearchParams(window.location.search);

	// this boolean will track whether any filters were set via URL parameters
	let urlParametersSet = false;
	// check if topic filter is being set via URL parameter
	if (searchParams.has('topic')) {
		let topicIds = searchParams.get('topic').split('|');
		this.$topicFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

		for (let i = 0; i < topicIds.length; i++) {
			let topicId = topicIds[i];

			let topicNode = this.$topicFilter.find(`[data-id="${topicId}"]`); // get the node by ID
			this.$topicFilter.jstree('select_node', topicNode); // select the node

		}

		this.$topicFilter.jstree('close_all'); // close all nodes

	}

	// check if industry filter is being set via URL parameter
	if (searchParams.has('industry')) {
		let industryIds = searchParams.get('industry').split('|');
		this.$industryFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

		for (let i = 0; i < industryIds.length; i++) {
			let industryId = industryIds[i];

			let industryNode = this.$industryFilter.find(`[data-id="${industryId}"]`); // get the node by ID
			this.$industryFilter.jstree('select_node', industryNode); // select the node
		}

		this.$industryFilter.jstree('close_all'); // close all nodes

	}

	// check if type filter is being set via URL parameter
	if (searchParams.has('type')) {

		let typeIds = searchParams.get('type').split('|');

		this.$typeFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

		for (let i = 0; i < typeIds.length; i++) {
			
			let typeId = typeIds[i];

			let typeNode = this.$typeFilter.find(`[data-id="${typeId}"]`); // get the node by ID
			this.$typeFilter.jstree('select_node', typeNode); // select the node

		}

		this.$typeFilter.jstree('close_all'); // close all nodes

	}

	this.$submitFiltersButton.on('click', function() {
		self.submitFilters();
	});

	this.initPulsateFilterDropdowns();

	// Set up the wrapper for active filter tags
	this.$activeFilterTagsWrapper = this.options.$el.find(`.${self.options.baseClass}__activeFilterTags`);
	if (!this.$activeFilterTagsWrapper.length) {
		this.$activeFilterTagsWrapper = $('<div>', {
			'class': `${self.options.baseClass}__activeFilterTags`
		});
		this.options.$el.find(`.${self.options.baseClass}__filtersWrapper`).after(this.$activeFilterTagsWrapper);
	}

	// Update the active filter tags based on initially selected items
	this.updateActiveFilterTags();

	this.$activeFilterTagsWrapper.on('click', `.${self.options.baseClass}__activeFilterTag`, function(e) {
		e.preventDefault();
		self.setButtonToLoading();

		let tagType = $(this).data('tagType');

		switch (tagType) {
			case 'topic':
				self.clearTopicFilter();
				break;
			case 'industry':
				self.clearIndustryFilter();
				break;
			case 'type':
				self.clearTypeFilter();
				break;
		}

		self.submitFilters();
	});

};

EventListingsWithFilters.prototype.initFilters = function () {

	var self = this;

	this.$topicFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			}
		},
		"checkbox" : {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins" : [ "checkbox" ]
	});

	this.$industryFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			}
		},
		"checkbox" : {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins" : [ "checkbox" ]
	});

	this.$typeFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			}
		},
		"checkbox" : {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins" : [ "checkbox" ]
	});

	// when a dropdown filter heading is clicked
	this.$dropdownFilterHeadings.on('click', function() {

		let $dropdownFilter = $(this).closest(`.${self.options.baseClass}__dropdownFilter`);

		// check if the filter is currently active, and toggle
		if ($dropdownFilter.hasClass(`${self.options.baseClass}__dropdownFilter--active`))
		{
			self.closeDropdownFilter($dropdownFilter);
		}
		else
		{
			self.openDropdownFilter($dropdownFilter);
		}
		
	});

	// setting up our timeline to open/close filters
	this.filterCollapseTimeline = gsap.timeline({
		defaults: {
			duration: 0.3
		}
	})
	.to(self.$filterCollapseIndicator, {
		rotation: 0,
		duration: 0.35,
		ease: "power1.inOut"
	}, 0)
	.to(self.$filterCollapseWrapper, {
		height: 'auto',
	}, 0).reverse();

	// when a dropdown filter is changed
	this.$topicFilter.on('changed.jstree', function(e, data) {

		self.handleDropdownFilterChange($(this), data);

	});

	this.$industryFilter.on('changed.jstree', function(e, data) {

		self.handleDropdownFilterChange($(this), data);

	});

	this.$typeFilter.on('changed.jstree', function(e, data) {

		self.handleDropdownFilterChange($(this), data);

	});

	// when clicking outside the filters, close them
	$(`body`).on('click', function() {
		
		if(window.Breakpoint.value != "xsmall" && window.Breakpoint.value != "small"){
			self.closeAllDropdownFilters();
		}

	});

	// when clicking a filter, don't close the filters (stops the above function from triggering)
	this.$filterWrappers.on('click', function(e) {
		e.stopPropagation();
	});

};

// this function handles a dropdown filter change
EventListingsWithFilters.prototype.handleDropdownFilterChange = function($changedFilter, data) {

	var self = this;

	// jstree calls the change event in some situations where we don't want to pulsate the button, so we check
	// for those cases and exit early
	if (data.action == 'ready' || data.action == 'deselect_all') {
		return;
	}

	/*
	let $filterParent = $changedFilter.closest(`.${self.options.baseClass}__dropdownFilter`);

	if (data.selected.length) {
		$filterParent.addClass(self.selectedDropdownFilterClass);
	}
	else {
		$filterParent.removeClass(self.selectedDropdownFilterClass);
	}
	*/

};

// Handles opening a dropdown filter
EventListingsWithFilters.prototype.openDropdownFilter = function($dropdownFilter) {

	var self = this;

	let $filterWrapper = $dropdownFilter.find(`.${self.options.baseClass}__dropdownFilter__filterWrapper`);

	$dropdownFilter.addClass(`${self.options.baseClass}__dropdownFilter--active`);

	gsap.timeline()
	.set($filterWrapper, {
		overflow: 'hidden'
	})
	.to($filterWrapper, {
		height: 'auto',
		duration: 0.5,
	})
	.set($filterWrapper, {
		overflow: 'auto'
	});

};

// Closes all dropdown filters
EventListingsWithFilters.prototype.closeAllDropdownFilters = function() {

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__dropdownFilter`).each(function() {

		self.closeDropdownFilter($(this));

	});

};

// Closes a dropdown filter
EventListingsWithFilters.prototype.closeDropdownFilter = function($dropdownFilter) {

	var self = this;

	let $filterWrapper = $dropdownFilter.find(`.${self.options.baseClass}__dropdownFilter__filterWrapper`);

	$dropdownFilter.removeClass(`${self.options.baseClass}__dropdownFilter--active`);

	gsap.timeline()
	.set($filterWrapper, {
		overflow: 'hidden'
	})
	.to($filterWrapper, {
		height: 0,
		duration: 0.35,
	})
	.set($filterWrapper, {
		overflow: 'auto'
	});

};

EventListingsWithFilters.prototype.submitFilters = function($dropdownFilter) {

	var self = this;




	// get filters and assemble URL
	let submitFiltersUrl = '//' + location.host + location.pathname;

	// topic filters
	let selectedTopicFilters = this.$topicFilter.jstree('get_bottom_checked', true);
	let selectedTopicIds = [];

	// for each selected topic filter
	for (let i = 0; i < selectedTopicFilters.length; i++) {
		selectedTopicIds = [...new Set([...selectedTopicIds,...[selectedTopicFilters[i].data.id.toString()] ])]; // filter out duplicates
	}

	// industry filters
	let selectedIndustryFilters = this.$industryFilter.jstree('get_checked', true);
	let selectedIndustryIds = [];

	// for each selected industry filter
	for (let i = 0; i < selectedIndustryFilters.length; i++) {
		selectedIndustryIds = [...new Set([...selectedIndustryIds,...[selectedIndustryFilters[i].data.id.toString()] ])]; // filter out duplicates
	}

	// type filters
	let selectedTypeFilters = this.$typeFilter.jstree('get_checked', true);
	let selectedTypeIds = [];

	// for each selected type filter
	for (let i = 0; i < selectedTypeFilters.length; i++) {
		selectedTypeIds = [...new Set([...selectedTypeIds,...[selectedTypeFilters[i].data.id.toString()] ])]; // filter out duplicates
	}

	let parameterString = '';

	if (selectedTopicIds.length) {
		parameterString += '?topic=' + selectedTopicIds.join('|');
	}

	if (selectedIndustryIds.length) {

		if (parameterString) {
			parameterString += '&';
		}
		else {
			parameterString += '?';
		}

		parameterString += 'industry=' + selectedIndustryIds.join('|');
	}

	if (selectedTypeIds.length) {

		if (parameterString) {
			parameterString += '&';
		}
		else {
			parameterString += '?';
		}

		parameterString += 'type=' + selectedTypeIds.join('|');
	}

	submitFiltersUrl += parameterString;

	submitFiltersUrl += '#' + this.componentId;

	if (parameterString != location.search) {

		window.location.href = submitFiltersUrl;

		this.setButtonToLoading();

	}
	else {
		this.pulsateFilterDropdowns();
	}

};

EventListingsWithFilters.prototype.setButtonToLoading = function() {

	var self = this;

	this.$submitFiltersButton.addClass(this.submitFiltersButtonLoadingClass);
	this.$submitFiltersButton.prop("disabled",true);

};

EventListingsWithFilters.prototype.initPulsateFilterDropdowns = function() {

	var self = this;

	this.pulsateFiltersTimeline = gsap.timeline({
		paused: true
	})
	.to(self.$dropdownFilterPulsors, {
		duration: 0.5,
		opacity: 1
	})
	.to(self.$dropdownFilterPulsors, {
		duration: 0.5,
		opacity: 0
	});

};

EventListingsWithFilters.prototype.pulsateFilterDropdowns = function() {

	var self = this;

	this.pulsateFiltersTimeline.restart();

};

export default EventListingsWithFilters;

EventListingsWithFilters.prototype.updateActiveFilterTags = function() {
	var self = this;

	this.$activeFilterTagsWrapper.empty(); // clear out any existing filter tags

	let selectedTopicFilters = this.$topicFilter.jstree('get_bottom_checked', true);
	let selectedIndustryFilters = this.$industryFilter.jstree('get_checked', true);
	let selectedTypeFilters = this.$typeFilter.jstree('get_checked', true);

	// topic filter tag
	if (selectedTopicFilters.length) {
		let topicFiltersString = 'Topic: ';
		let fullTopicFiltersString = 'Topic: ';
		const isMobile = MOBILE_BREAKPOINTS.includes(window.Breakpoint.value);
		for (let i = 0; i < selectedTopicFilters.length; i++) {
			const filter = selectedTopicFilters[i];
			if (isMobile) {
				// Mobile: compact format — «filtre_1 or N others»
				if (selectedTopicFilters.length < 3) {
					if (i > 0) {
						topicFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
					}
					topicFiltersString += filter.text.trim();
				} else {
					if (i == 0) {
						topicFiltersString = `Topic: ${filter.text.trim()} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (selectedTopicFilters.length-1) + ` others`;
					}
				}
			} else {
				// Desktop: full format — «filtre_1 or filtre_2 or filtre_xx»
				if (i > 0) {
					topicFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				topicFiltersString += filter.text.trim();
			}
			if (i > 0) {
				fullTopicFiltersString += ` or `;
			}
			fullTopicFiltersString += filter.text.trim();
		}
		self.addActiveFilterTag(topicFiltersString, 'topic', fullTopicFiltersString);
	}

	// industry filter tag
	if (selectedIndustryFilters.length) {
		let industryFiltersString = 'Industry: ';
		let fullIndustryFiltersString = 'Industry: ';
		const isMobile = MOBILE_BREAKPOINTS.includes(window.Breakpoint.value);
		for (let i = 0; i < selectedIndustryFilters.length; i++) {
			const filter = selectedIndustryFilters[i];
			if (isMobile) {
				// Mobile: compact format — «filtre_1 or N others»
				if (selectedIndustryFilters.length < 3) {
					if (i > 0) {
						industryFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
					}
					industryFiltersString += filter.text.trim();
				} else {
					if (i == 0) {
						industryFiltersString = `Industry: ${filter.text.trim()} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (selectedIndustryFilters.length-1) + ` others`;
					}
				}
			} else {
				// Desktop: full format — «filtre_1 or filtre_2 or filtre_xx»
				if (i > 0) {
					industryFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				industryFiltersString += filter.text.trim();
			}
			if (i > 0) {
				fullIndustryFiltersString += ` or `;
			}
			fullIndustryFiltersString += filter.text.trim();
		}
		self.addActiveFilterTag(industryFiltersString, 'industry', fullIndustryFiltersString);
	}

	// event type filter tag
	if (selectedTypeFilters.length) {
		let typeFiltersString = 'Event Type: ';
		let fullTypeFiltersString = 'Event Type: ';
		const isMobile = MOBILE_BREAKPOINTS.includes(window.Breakpoint.value);
		for (let i = 0; i < selectedTypeFilters.length; i++) {
			const filter = selectedTypeFilters[i];
			if (isMobile) {
				// Mobile: compact format — «filtre_1 or N others»
				if (selectedTypeFilters.length < 3) {
					if (i > 0) {
						typeFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
					}
					typeFiltersString += filter.text.trim();
				} else {
					if (i == 0) {
						typeFiltersString = `Event Type: ${filter.text.trim()} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (selectedTypeFilters.length-1) + ` others`;
					}
				}
			} else {
				// Desktop: full format — «filtre_1 or filtre_2 or filtre_xx»
				if (i > 0) {
					typeFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				typeFiltersString += filter.text.trim();
			}
			if (i > 0) {
				fullTypeFiltersString += ` or `;
			}
			fullTypeFiltersString += filter.text.trim();
		}
		self.addActiveFilterTag(typeFiltersString, 'type', fullTypeFiltersString);
	}
};

EventListingsWithFilters.prototype.addActiveFilterTag = function(tagText, tagType, tagTitle) {
	var self = this;

	let $activeFilterTagElement = $('<a>', {
		'href': '#',
		'class': `${self.options.baseClass}__activeFilterTag`,
		'data-tag-type': tagType,
		'title': tagTitle
	});

	$activeFilterTagElement.append(
		$('<span>', { 'class': `${self.options.baseClass}__activeFilterTag__closeX` })
	);

	let $tagValueElement = $('<span>', {
		'class': `${self.options.baseClass}__activeFilterTag__value`
	});

	$tagValueElement.html(tagText); 
	$activeFilterTagElement.append($tagValueElement);

	this.$activeFilterTagsWrapper.append($activeFilterTagElement);
};

EventListingsWithFilters.prototype.clearTopicFilter = function() {
	this.$topicFilter.jstree('deselect_all');
};

EventListingsWithFilters.prototype.clearIndustryFilter = function() {
	this.$industryFilter.jstree('deselect_all');
};

EventListingsWithFilters.prototype.clearTypeFilter = function() {
	this.$typeFilter.jstree('deselect_all');
};
